import {
  CreateAttendanceBalanceCarryoverDocument,
  CreateAttendanceBalanceCarryoverMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateAttendanceBalanceCarryover = () => {
  const [createAttendanceBalanceCarryover, { loading }] = useMutation(
    CreateAttendanceBalanceCarryoverDocument,
    {
      extractorFn: (data) => data.attendanceMutations.createAttendanceBalanceCarryover,
    }
  )

  const createBalanceCarryover = (variables: CreateAttendanceBalanceCarryoverMutationVariables) => {
    return createAttendanceBalanceCarryover({
      variables,
    })
  }

  return {
    loading,
    createBalanceCarryover,
  }
}
